import {
  ACTIVATE_LOADER,
  DEACTIVATE_LOADER,
  HIDE_COMMON_MESSAGE,
  SCROLL_INTO_VIEW,
  SCROLL_TO_TOP,
  SWITCH_DEVICE,
  TOGGLE_SIDEBAR
} from '../../action-contants';
import { createCTObj, injectIntoDataLayer } from '../../../utils/library';
import { EVENT_NAME, ERROR_TYPE } from '../../../utils/constants';
function activeLoader(data) {
  return {
    type: ACTIVATE_LOADER,
    data
  };
}

function disabledLoader(data) {
  return {
    type: DEACTIVATE_LOADER,
    data
  };
}

export function scrollToTopAction() {
  return { type: SCROLL_TO_TOP };
}

function switchDeviceAction(device) {
  return { type: SWITCH_DEVICE, device };
}

function toggleSidebarAction() {
  return { type: TOGGLE_SIDEBAR };
}

export function activateLoader(data) {
  return (dispatch) => {
    dispatch({ type: HIDE_COMMON_MESSAGE });
    dispatch(activeLoader(data));
  };
}

export function disableLoader() {
  return (dispatch) => {
    dispatch(disabledLoader());
  };
}

export function scrollToTop() {
  return (dispatch) => dispatch(scrollToTopAction());
}

export function scrollToError(error, dispatch, a, props) {
  const createCTObjReq = createCTObj({
    error_type: ERROR_TYPE.VALIDATION,
    error,
    flow_type: EVENT_NAME[props.form] && EVENT_NAME[props.form].flowType,
    error_code: 0
  });
  const e = {
    ...createCTObjReq,
    ...props.values
  };

  injectIntoDataLayer(EVENT_NAME[props.form], e);

  injectIntoDataLayer(EVENT_NAME[props.form] && EVENT_NAME[props.form].formName, e);

  return dispatch({ type: SCROLL_INTO_VIEW, data: error });
}

export function toggleSidebar() {
  return (dispatch) => dispatch(toggleSidebarAction());
}

export function switchDevice(device) {
  return (dispatch) => dispatch(switchDeviceAction(device));
}
